import { UserGroup } from "../enums/UserGroup";
import { AdGroup } from "../types/AdGroup";


export const adGroups: AdGroup[] = [
    
    {
        
        guid: 'c02adcb3-1025-4bb0-9262-ecdbdd1c5685',
        name: UserGroup.BatteryMonitor

    },
    
    {

        guid: 'afec74c8-04bf-4f0b-8452-6a0ef50408b9',
        name: UserGroup.CommonAreaAccess

    },

    {

        guid: 'fa435ded-7b92-4739-b2a5-0e7e2d95dac9',
        name: UserGroup.CommonDoorSchedule

    },

    {
        
        guid: 'b31d8908-ffa2-44da-a625-149f09c77d67',
        name: UserGroup.ExternalBatteryMonitor

    },

    {

        guid: 'd364b449-4152-494c-9e61-d2ab0be68388',
        name: UserGroup.Diagnostics

    },

    {
        
        guid: '670fc47c-3665-4ca6-b742-24a7a59c6522',
        name: UserGroup.ESSSupervisor

    },

    {

        guid: '1dd58d11-ebd3-40f7-8042-ec01ecdd967f',
        name: UserGroup.ExternalCommonAreaUsers,

    },

    {

        guid: 'c4fd1014-dd15-4ed5-a97e-9bfc9bd3198b',
        name: UserGroup.ExternalGymUsers,

    },

    {
        
        guid: 'bc371ef7-3021-4bf4-b896-8a72a5672c55',
        name: UserGroup.GymCompetency

    },

    {
        
        guid: 'b0ae025e-74a1-44ed-abbd-e415df76d4a2',
        name: UserGroup.IotGatewayDashboard

    },

    {
        
        guid: 'cb867e7f-fbad-4bc0-98e6-468215888e9f',
        name: UserGroup.ExternalIotGatewayDashboard

    },

    {
        
        guid: '4a5db0b6-ad18-411c-8d7f-910335d693a9',
        name: UserGroup.IotDeviceDashboard

    },

    {
        
        guid: '8b40a328-19d6-44c8-ba9b-49f70c75e687',
        name: UserGroup.ExternalIotDeviceDashboard

    },

    {
        
        guid: 'a801e3c5-7c4e-4c4b-aa24-6ad508b9abeb',
        name: UserGroup.NPIHousing

    },

    {
        
        guid: '089dff1e-2121-4dd9-a6ba-032db015e094',
        name: UserGroup.NPIOps

    },

    

    {
        
        guid: '3ee54241-fa9d-4d0b-98e4-12a19d7d1e3d',
        name: UserGroup.SpokeDashboard
        
    },

    {
        
        guid: 'c52d9d05-1430-4084-b51a-cf5d3cf78d6d',
        name: UserGroup.VillageWiFi

    },

    {

        guid: 'b789f7d3-aa9d-4358-9f91-579dd23b04c3',
        name: UserGroup.WaioReception

    },

    {

        guid: '3c90b8bc-e9f0-4634-8a30-d5c55d7f82d8',
        name: UserGroup.WaioSecurity

    },

    {
        
        guid: 'c7885297-2471-403f-b29a-baf4107b87fb',
        name: UserGroup.WaioUsers

    },
    
    
];


